import { createSlice } from "@reduxjs/toolkit";

interface EmailResponseValue {
  email: string;
}
const initialState: EmailResponseValue = {
  email: "",
};
export const resetPasswordEmailSlice = createSlice({
  name: "resetPassword",
  initialState,
  reducers: {
    ResetPasswordEmail(state, action) {
      state.email = action.payload.email;
    },
  },
});
export const resetPasswordEmailActions = resetPasswordEmailSlice.actions;
export default resetPasswordEmailSlice.reducer;
